import {
  sendRequest,
} from 'utils/httpClient';
import {
  MultiMediaRequestDTO,
  MultiMediaResponseDTO,
  MultiMediaResponse,
  GetApiPatientSearchPatientsParams,
} from 'dtos';
import {
  formatSearchPatient,
} from 'pages/Dashboard/pages/Charts/helper';
import {
  PaginatedPatientList,
  RequestMultiMediaDataParams,
} from 'pages/Dashboard/types/patient';
import {
  getApiPatientSearchPatients,
  postApiMultimediaGetPatientMultiMedia,
} from 'endpoints';

function normalizeMultiMediaResponseDTO(dto: MultiMediaResponseDTO) {
  return dto?.list ?? [];
}

export const getPatients = async ({
  search,
  page,
  pageSize,
}: { search: string; page: number; pageSize?: number }): Promise<PaginatedPatientList> => {
  const _patients = await getApiPatientSearchPatients({
    searchText: search,
    page: page ?? 0,
    pageSize: pageSize ?? 25,
  } as GetApiPatientSearchPatientsParams);
  const patients = (_patients.data ?? []).map(formatSearchPatient);
  return { data: patients, pageProperties: _patients.pageProperties };
};

export const getMultiMedia = (data: MultiMediaRequestDTO): Promise<MultiMediaResponse[]> => (
  sendRequest<MultiMediaResponseDTO>({
    url: 'api/multimedia/requestMultiMedia',
    method: 'POST',
    data,
  }).then(normalizeMultiMediaResponseDTO)
);

export const getPatientsMultimedia = async ({
  pagination,
  setTotalSize,
  ...data
}: RequestMultiMediaDataParams): Promise<MultiMediaResponse[]> => {
  const results = await postApiMultimediaGetPatientMultiMedia(
    {
      ...data,
      pageRequest: {
        page: pagination?.pageIndex ?? 0,
        pageSize: pagination?.pageSize ?? 2,
      },
    },
  );

  setTotalSize?.(results?.pageProperties?.totalSize ?? 0);

  return results?.list ?? [];
};

export function getTextFileContent(url: string, enabled: boolean = false) {
  return enabled
    ? sendRequest<string>({
      url,
      method: 'GET',
    }, undefined, { isExternal: true })
    : Promise.resolve(null);
}
